import { useEffect, useState } from 'react';

import authenticationService from '../services/authentication';
import { BaseUser } from '../../../src/types';

const useUser = () => {
    const [ user, setUser ] = useState<BaseUser>();

    useEffect(() => {
        (async () => {
            authenticationService.addTokenInterceptor();
            const authorizedUser = await authenticationService.getAuthorizedUser()
            if (authorizedUser) {
                setUser(authorizedUser);
            }
        })();
    }, [setUser])

    return { user, setUser };
};

export default useUser;